import PrivateRequestBase from "./rootRequest/PrivateRequestBase";

export function seeListRequest(flightId) {
  return PrivateRequestBase("get", `api/processedflightresource/?flight=${flightId}&is_mapbox_layer=true`)
}